import React from 'react';
import { useIntl } from 'react-intl';

import { MainTabView } from '@marketplace/common';
import { Button } from '@marketplace/ui-elements';

import { BaseTemplate } from '../base-template';
import { ApplicationDescription } from './application-short-description';
import { BackToAppsSvg } from './svg';

import useApplicationPage from './application-page.hook';

import './style.scss';

export function ApplicationPage() {
  const {
    handleOnClickBackToApps,
    loading,
    data,
    partnerDetailsData,
    handleChangeTab,
    tabsContent,
    activeTab,
  } = useApplicationPage();

  const { formatMessage } = useIntl();

  return (
    <BaseTemplate>
      <div className="application-page">
        <div className="application-page__breadcrumbs">
          <Button
            variant="secondary"
            icon={BackToAppsSvg}
            onClick={handleOnClickBackToApps}
          >
            {formatMessage({ id: 'app_gallery_back_to_apps' })}
          </Button>
        </div>
        <div className="application-page__container">
          {loading && <p>Loading...</p>}

          {data?.id && <ApplicationDescription data={data} partnerDetailsData={partnerDetailsData} />}

          <MainTabView
            activeIndex={activeTab}
            setActiveIndex={(activeTab: number) => handleChangeTab(activeTab)}
            tabsContent={tabsContent}
            tableView={true}
          />
        </div>
      </div>
    </BaseTemplate>
  );
}
